@if (editMode()) {
  <div class="btn-edit">
    <button class="button" (click)="onAddItem()">Add Item</button>
    <button class="button" (click)="onAddGallery()">Add Gallery</button>
  </div>
}

<section class="{{titleContent?.attributes?.bg}}-content"
  [ngClass]="titleContent?.attributes?.showTitle ? 'header-content' : 'header-content--noTitle'">
  <app-page-title [type]="type"></app-page-title>
</section>
@for (article of articles; track article.id; let i = $index) {
  @if (article.attributes.gallery) {
    <app-gallery-article [article]="article" (deleted)="onDeleted($event)"></app-gallery-article>
  } @else if (i % 2 === 0) {
    <app-animated-article-left [article]="article" (deleted)="onDeleted($event)"></app-animated-article-left>
  } @else {
    <app-animated-article-right [article]="article" (deleted)="onDeleted($event)"></app-animated-article-right>
  }
}